import script from "./InformationSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./InformationSlider.vue?vue&type=script&setup=true&lang=js"

import "./InformationSlider.vue?vue&type=style&index=0&id=242e6186&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-242e6186"]])

export default __exports__